import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {AgencyHeader} from '../AgencyHeader';
import {AgencyTabs} from '../AgencyTabs';
import {AlertsConfiguration} from '../../common/AlertsConfiguration';

class AgencyAlertsConfigurationClass extends Component {
    render() {
        const {t} = this.props;

        return (
            <section className="section-content agency-page agency-alerts-page">
                <AgencyHeader/>
                <AgencyTabs activeTab="-fourth"/>
                <div className="section-body h-items">
                    <div className="section-body-item -wider box">
                        <header className="box-header">
                            <h2 className="box-title">{t('agency_alerts_configuration.title')}</h2>
                        </header>
                        <div className="form-row">
                            <label>{t('agency_alerts_configuration.description')}</label>
                            <label>{t('agency_alerts_configuration.email_description')}</label>
                        </div>
                        <AlertsConfiguration/>
                    </div>
                </div>
            </section>
        );
    }
}

export const AgencyAlertsConfiguration = withTranslation()(AgencyAlertsConfigurationClass);
export default AgencyAlertsConfiguration;
